import { takeLatest, call, put, select } from "redux-saga/effects";
import { MENU_REQUESTED, MENU_REQUEST_FAILED } from "./menuActions";
import { getMenu } from "apis/menu";
import { receiveMenu } from "./menuActions";
import { doCall } from "common/genericSaga";

export function* doRequestMenu() {
  let menu = yield select(state => state.menu);
  const response = menu.items ? menu.items : yield call(getMenu);
  yield put(receiveMenu(response));
}

export function* watchMenu() {
  yield takeLatest(MENU_REQUESTED, doCall(doRequestMenu, MENU_REQUEST_FAILED));
}
